// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__wBMYj","unreadBadge":"styles_unreadBadge__Lsg2n","modalContent":"styles_modalContent__12UTZ","modal":"styles_modal__2xnUg"};